/* unplugin-vue-components disabled */import { render } from "./cp_fav.vue?vue&type=template&id=0e7f6412&scoped=true"
import script from "./cp_fav.vue?vue&type=script&lang=js"
export * from "./cp_fav.vue?vue&type=script&lang=js"

import "./cp_fav.vue?vue&type=style&index=0&id=0e7f6412&scoped=true&lang=css"

import exportComponent from "E:\\Work\\Code\\HZY.Mobile\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7f6412"]])

export default __exports__